export const extractCategoriesUnlocalized = (
  hierarchicalCategories: {
    lvl10?: string[]
    lvl20?: string[]
    lvl30?: string[]
    lvl40?: string[]
  },
  categoryPageId2: string[]
): { category1: string; category2: string; category4: string } => {
  const defaultValues = { category1: '', category2: '', category4: '' }

  // Get the depth of the category from hierarchicalCategories key names
  const hierarchyLevel = Object.keys(hierarchicalCategories)
    .map(key => parseInt(key.replace('lvl', '').replace('0', ''))) // Extract level number
    .sort()

  if (!hierarchyLevel.length) return defaultValues

  const deepestLevel = Math.max(...hierarchyLevel)

  // Find the first category page id has the biggest hierarchy depth
  const targetCategoryPageId = categoryPageId2?.find(categoryId => {
    const splitCategory = categoryId.split('>')
    return splitCategory.length === deepestLevel
  })

  if (!targetCategoryPageId) {
    return defaultValues
  }

  const targetCategoriesList = targetCategoryPageId
    .split('>')
    .map(el => el.trim())

  const genderCategory = targetCategoriesList.find(category =>
    ['man', 'woman'].includes(category)
  )

  const categoriesWithoutGender = targetCategoriesList.filter(
    el => !['man', 'woman'].includes(el)
  )

  const [_brand, ...productCategories] = categoriesWithoutGender

  if (productCategories.length <= 2) {
    return {
      category1: productCategories[0] || '',
      category2: productCategories[1] || '',
      category4: genderCategory || 'unisex',
    }
  }

  return {
    category1: productCategories.at(-2) || '',
    category2: productCategories.at(-1) || '',
    category4: genderCategory || 'unisex',
  }
}
